var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "view-button" },
                on: { click: _vm.toggleView }
              },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: _vm.viewMode === "table" ? "th-large" : "list"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "view-button",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.viewMode === "table" ? "Канбан" : "Таблица") +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            ),
            _vm._v(" "),
            _vm.canEditRecruitJobPostings()
              ? _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.showModal(null, false)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        Новое объявление\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c(
                "filters-drawer",
                {
                  attrs: {
                    "hide-search": true,
                    "is-busy": _vm.isBusy,
                    "filter-tags": _vm.activeFilterTags
                  },
                  on: {
                    "remove-tag": _vm.removeFilterTag,
                    submit: _vm.onSearch,
                    clear: _vm.onClearFilters
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Вакансии")
                      ]),
                      _vm._v(" "),
                      _c("vacancy-multi-select", {
                        ref: "vacancy_multi_select",
                        attrs: { id: "vacancy-multi-select" },
                        on: { onSelect: _vm.onSelectVacancy }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Дата публикации")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-start-opened-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.start_opened_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "start_opened_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.start_opened_date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "auto" } },
                            [_c("span", [_vm._v("—")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-end-opened-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.end_opened_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "end_opened_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.end_opened_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Дата первого выхода в смену")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-start-closed-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.start_closed_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "start_closed_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.start_closed_date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "auto" } },
                            [_c("span", [_vm._v("—")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-end-closed-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.end_closed_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "end_closed_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.end_closed_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Объекты")
                      ]),
                      _vm._v(" "),
                      _c("location-multi-select", {
                        ref: "location_multi_select",
                        attrs: { id: "location-multi-select" },
                        on: { onSelect: _vm.onSelectLocation }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Ответственные")
                      ]),
                      _vm._v(" "),
                      _c("user-multi-select", {
                        ref: "user_multi_select_assigned",
                        attrs: {
                          id: "user-multi-select-assigned",
                          title: "Ответственные"
                        },
                        on: { onSelect: _vm.onSelectUserAssigned }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Статус")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-statuses",
                          size: "sm",
                          options: _vm.statusOptions
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Сервис")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-provider-id",
                          size: "sm",
                          options: _vm.providerOptions
                        },
                        model: {
                          value: _vm.filters.provider_id,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "provider_id", $$v)
                          },
                          expression: "filters.provider_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  {
                    staticClass: "page-table-container",
                    class: { "border-0": _vm.viewMode === "kanban" }
                  },
                  [
                    _vm.viewMode === "table"
                      ? _c("b-table", {
                          ref: "recruit_job_postings",
                          staticClass: "custom-table mb-0 text-small",
                          attrs: {
                            id: "recruit-job-postings",
                            "sticky-header": "",
                            selectable: "",
                            "select-mode": "single",
                            responsive: "",
                            busy: _vm.isBusy,
                            items: _vm.items,
                            fields: _vm.renderedFields,
                            "no-provider-filtering": "",
                            "no-provider-paging": "",
                            "no-provider-sorting": "",
                            "no-local-sorting": ""
                          },
                          on: {
                            "update:busy": function($event) {
                              _vm.isBusy = $event
                            },
                            "sort-changed": _vm.sortChanged,
                            "row-dblclicked": _vm.onRowClicked
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "table-busy",
                                fn: function() {
                                  return [
                                    _c("tables-skeleton", {
                                      attrs: {
                                        fields: _vm.renderedFields,
                                        rows: 4
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "cell(assigned)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getAssignedName(row.item.assigned)
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(status_id)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          row.item.status_name ||
                                            _vm.getStatusText(
                                              row.item.status_id
                                            )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(opened_date)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatTableDate(
                                            row.item.opened_date
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(action)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass: "custom-dropdown",
                                        attrs: {
                                          variant: "link",
                                          "toggle-class":
                                            "text-decoration-none box-shadow-none",
                                          "no-caret": ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function() {
                                                return [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name:
                                                        "buttons/ellipsis_vertical",
                                                      size: 15
                                                    }
                                                  })
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: { variant: "success" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showModal(
                                                  row.item.id,
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                name: "buttons/eye",
                                                size: 14
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Смотреть\n              "
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.canEditRecruitJobPostings()
                                          ? _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.showModal(
                                                      row.item.id,
                                                      false
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "buttons/edit",
                                                    size: 14
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                Редактировать\n              "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canEditRecruitJobPostings()
                                          ? _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: { variant: "danger" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onRemove(row)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    name: "buttons/trash",
                                                    size: 14
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                Удалить\n              "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2659076906
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.viewMode === "kanban"
                      ? _c("kanban", {
                          attrs: {
                            items: _vm.items,
                            columns: _vm.kanbanColumns,
                            "group-name": "recruit-job-postings"
                          },
                          on: { "status-updated": _vm.kanbanUpdateStatus },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "card",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "kb-card shadow-sm",
                                        attrs: { "no-body": "" },
                                        on: {
                                          dblclick: function($event) {
                                            return _vm.onRowClicked(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center w-100"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-weight-bold text-truncate mr-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      item.location_vacancy_name
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-dropdown",
                                              {
                                                staticClass:
                                                  "custom-dropdown p-0 m-0 custom-btn-secondary",
                                                staticStyle: {
                                                  width: "16px !important"
                                                },
                                                attrs: {
                                                  variant: "link",
                                                  "toggle-class":
                                                    "text-decoration-none box-shadow-none flex-shrink-0",
                                                  "no-caret": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "button-content",
                                                      fn: function() {
                                                        return [
                                                          _c("v-icon", {
                                                            attrs: {
                                                              name:
                                                                "buttons/ellipsis_vertical",
                                                              size: 15
                                                            }
                                                          })
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "b-dropdown-item",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.showModal(
                                                          item.id,
                                                          true
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        name: "buttons/eye",
                                                        size: 14
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                    Смотреть\n                  "
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.canEditRecruitJobPostings()
                                                  ? _c(
                                                      "b-dropdown-item",
                                                      {
                                                        attrs: {
                                                          variant: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.showModal(
                                                              item.id,
                                                              false
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            name:
                                                              "buttons/edit",
                                                            size: 14
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                    Редактировать\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.canEditRecruitJobPostings()
                                                  ? _c(
                                                      "b-dropdown-item",
                                                      {
                                                        attrs: {
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onRemove(
                                                              { item: item }
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            name:
                                                              "buttons/trash",
                                                            size: 14
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "\n                    Удалить\n                  "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center w-100 small text-truncate"
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2 flex-shrink-0",
                                              attrs: {
                                                name: "navbar/locations",
                                                size: 13
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "text-truncate" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.location_name)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center w-100 small"
                                          },
                                          [
                                            _c("v-icon", {
                                              staticClass: "mr-2 flex-shrink-0",
                                              attrs: {
                                                name: "buttons/calendar",
                                                size: 13
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatTableDate(
                                                    item.opened_date
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.provider_name
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center w-100 small text-truncate"
                                              },
                                              [
                                                _c("v-icon", {
                                                  staticClass:
                                                    "mr-2 flex-shrink-0",
                                                  attrs: {
                                                    name: "navbar/locations",
                                                    size: 13
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-truncate"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.provider_name)
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "w-100 m-0 border-light"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center w-100 small text-muted"
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "p-0 pl-1 mr-2 text-decoration-none",
                                                staticStyle: {
                                                  color: "#1A9167 !important"
                                                },
                                                attrs: { variant: "link" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onRowClicked(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Открыть\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "text-truncate" },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "mr-1",
                                                  attrs: { icon: "user" }
                                                }),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getAssignedName(
                                                        item.assigned
                                                      ) || "Не назначен"
                                                    ) +
                                                    "\n                "
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1078354012
                          )
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      }
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Нет созданных объявлений.")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Создайте новое объявление прямо сейчас")]),
                  _vm._v(" "),
                  _vm.canEditRecruitJobPostings()
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "custom-btn-primary mt-1",
                          on: {
                            click: function($event) {
                              return _vm.showModal(null, false)
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "buttons/plus", size: 12 }
                          }),
                          _vm._v("\n        Новое объявление\n      ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "recruitJobPostings_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("RecruitJobPosting", {
        ref: "recruit_job_posting",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b974e4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b974e4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitJobPostings.vue
// module id = null
// module chunks = 